import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import claimLegacyListApi from 'models/claims/claim/legacyList/Api.Claim.LegacyList';
import { useClaimEdit } from '../ClaimEdit.Hooks';

export default function ClaimEditLegacyClaimHistory() {
  const { lang } = getLocales();
  const { contract } = useClaimEdit();

  const { payload, isExecuting } = useApi({
    action: claimLegacyListApi,
    body: { appNumber: contract.appNumber },
  });

  return (
    <>
      <div style={{ margin: Theme.Size.XL, marginBottom: 0 }}>
        <h2 style={{ marginTop: 0 }}>{lang.legacyClaimHistory}</h2>
      </div>
      <table className={ThemeTableSimple} data-loading={isExecuting ? isExecuting : undefined}>
        <thead>
          <tr>
            <th>{lang.appNumber}</th>
            <th>{lang.authorizationNumber}</th>
            <th>{lang.dateCreated}</th>
            <th>{lang.status}</th>
            <th>{lang.type}</th>
            <th>
              {lang.dealer}/{lang.serviceAdvisor}
            </th>
            <th>{lang.totalAmountNoTax}</th>
          </tr>
        </thead>
        <tbody>
          <DataMap
            data={payload}
            render={({ data: item }) => (
              <tr key={item.id}>
                <td>{item.appNumberFull}</td>
                <td>
                  <a
                    href={'https://autoshieldportal.co/app_claims/claim/' + item.authorizationNumber}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.authorizationNumber}
                  </a>
                </td>
                <td>{item.dateCreate ? localizeDate(item.dateCreate, defaultDateTimeFormat) : 'N/A'}</td>
                <td>{item.claimStatusInfo}</td>
                <td>{item.typeName}</td>
                <td>{item.serviceAdviser}</td>
                <td>{item.claimTotalCost}</td>
              </tr>
            )}
          />
        </tbody>
      </table>
    </>
  );
}
